export const securitySettingId = Object.freeze({
    GRANT: 1,
    DENY: 2,
    VIEW_ONLY: 3,
    READ_WRITE: 4,
    NONE: 5,
    EMPTY: 6
});
